// extracted by mini-css-extract-plugin
export var caretAnchor = "_vq-0";
export var dropdownContent = "_vq-1";